module.exports = __webpack_public_path__ + "static/media/down-arrow.52c4c576.svg";